export default "__VITE_ASSET__CvEiVZBW__"